export const REPORT_DOWNLOAD_ENDPOINTS = Object.freeze({
    "Last Updated Temp Assignment Report": process.env.REACT_APP_REPORT_API + "taed/lastUpdated",
    "Active Temp Assignment Report": process.env.REACT_APP_REPORT_API + "taed/active",
    "Superuser Report": process.env.REACT_APP_REPORT_API + "user/superUser"
});